








































































































































































































































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { RolesModule } from '@/store/Settings/RolesModule';
import { AuthModule } from '@/store/Auth/AuthModule';
import CreateUpdateRoleRequest from '@/models/Settings/Roles/CreateUpdateRoleRequest';
import PageNames from '@/router/PageNames';

@Component({ name: 'RoleCreate' })
export default class extends SaascadaVueDialog {

    request: CreateUpdateRoleRequest = new CreateUpdateRoleRequest();

    get institutionConfig() {
        return AuthModule.me.institution.config;
    }

    get institutionLabels() {
        return AuthModule.me.institution.config.labels;
    }

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.request = new CreateUpdateRoleRequest();
        }
    }

    @Watch('request.readThirdPartyAccounts')
    async onReadThirdPartyAccountsChanged(val: boolean) {
        if (!val) {
            this.request.manageThirdPartyAccounts = false;
            this.request.manageThirdPartyPaymentOrders = false;
        }
    }

    @Watch('request.manageThirdPartyAccounts')
    async onManageThirdPartyAccountsChanged(val: boolean) {
        if (val) {
            this.request.readThirdPartyAccounts = true;
        }
    }

    @Watch('request.manageThirdPartyPaymentOrders')
    async onManageThirdPartyPaymentOrdersChanged(val: boolean) {
        if (val) {
            this.request.readThirdPartyAccounts = true;
        }
    }

    @Watch('request.readInstitutionalAccounts')
    async onReadInstitutionalAccountsChanged(val: boolean) {
        if (!val) {
            this.request.manageInstitutionalAccounts = false;
            this.request.manageInstitutionalPaymentOrders = false;
        }
    }

    @Watch('request.manageInstitutionalAccounts')
    async onManageInstitutionalAccountsChanged(val: boolean) {
        if (val) {
            this.request.readInstitutionalAccounts = true;
        }
    }

    @Watch('request.manageInstitutionalPaymentOrders')
    async onManageInstitutionalPaymentOrdersChanged(val: boolean) {
        if (val) {
            this.request.readInstitutionalAccounts = true;
        }
    }

    @Watch('request.readCustomerAccounts')
    async onReadCustomerAccountsChanged(val: boolean) {
        if (!val) {
            this.request.manageCustomerAccounts = false;
            this.request.manageCustomerPaymentOrders = false;
        }
    }

    @Watch('request.manageCustomerAccounts')
    async onManageCustomerAccountsChanged(val: boolean) {
        if (val) {
            this.request.readCustomerAccounts = true;
        }
    }

    @Watch('request.manageCustomerPaymentOrders')
    async onManageCustomerPaymentOrdersChanged(val: boolean) {
        if (val) {
            this.request.readCustomerAccounts = true;
        }
    }

    @Watch('request.readLendingAccounts')
    async onReadLendingAccountsChanged(val: boolean) {
        if (!val) {
            this.request.manageLendingAccounts = false;
        }
    }

    @Watch('request.manageLendingAccounts')
    async onManageLendingAccountsChanged(val: boolean) {
        if (val) {
            this.request.readLendingAccounts = true;
        }
    }

    @Watch('request.readProducts')
    async onReadProductsChanged(val: boolean) {
        if (!val) {
            this.request.manageProducts = false;
        }
    }

    @Watch('request.manageProducts')
    async onManageProductsChanged(val: boolean) {
        if (val) {
            this.request.readProducts = true;
        }
    }

    @Watch('request.readAccounting')
    async onReadAccountingChanged(val: boolean) {
        if (!val) {
            this.request.manageAccounting = false;
        }
    }

    @Watch('request.manageAccounting')
    async onManageAccountingChanged(val: boolean) {
        if (val) {
            this.request.readAccounting = true;
        }
    }

    @Watch('request.readReports')
    async onReadReportsChanged(val: boolean) {
        if (!val) {
            this.request.manageReports = false;
        }
    }

    @Watch('request.manageReports')
    async onManageReportsChanged(val: boolean) {
        if (val) {
            this.request.readReports = true;
        }
    }

    @Watch('request.readUsers')
    async onReadUsersChanged(val: boolean) {
        if (!val) {
            this.request.manageUsers = false;
        }
    }

    @Watch('request.manageUsers')
    async onManageUsersChanged(val: boolean) {
        if (val) {
            this.request.readUsers = true;
        }
    }

    @Watch('request.readRoles')
    async onReadRolesChanged(val: boolean) {
        if (!val) {
            this.request.manageRoles = false;
        }
    }

    @Watch('request.manageRoles')
    async onManageRolesChanged(val: boolean) {
        if (val) {
            this.request.readRoles = true;
        }
    }

    @Watch('request.readInstitutionSettings')
    async onReadInstitutionalSettingsChanged(val: boolean) {
        if (!val) {
            this.request.manageInstitutionSettings = false;
        }
    }

    @Watch('request.manageInstitutionSettings')
    async onManageInstitutionalSettingsChanged(val: boolean) {
        if (val) {
            this.request.readInstitutionSettings = true;
        }
    }

    @Watch('request.readAppMediums')
    async onReadAppMediumsChanged(val: boolean) {
        if (!val) {
            this.request.manageAppMediums = false;
        }
    }

    @Watch('request.manageAppMediums')
    async onManageAppMediumsChanged(val: boolean) {
        if (val) {
            this.request.readAppMediums = true;
        }
    }

    @Watch('request.readWebhooks')
    async onReadAWebHooksChanged(val: boolean) {
        if (!val) {
            this.request.manageWebhooks = false;
        }
    }

    @Watch('request.manageWebhooks')
    async onManageWebhooksChanged(val: boolean) {
        if (val) {
            this.request.readWebhooks = true;
        }
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;
            await RolesModule.createRole(this.request);

            if (RolesModule.newRoleId != null) {
                this.$router.push({ name: PageNames.Role, params: { id: RolesModule.newRoleId } });
            }
        }
    }

}
